module.exports = __webpack_public_path__ + "img/milva-logo-green.768dca75.svg";